import Vue from 'vue'

//时间
import moment from "moment";
import VueMomentJS from "vue-momentjs";

moment.locale("zh-cn")
Vue.use(VueMomentJS, moment);
